// extracted by mini-css-extract-plugin
export default {"wrapper":"Progressbar_wrapper__N11Qt","label":"Progressbar_label__CjA9M","likeAnimation":"Progressbar_likeAnimation__4Ea70"};